export const CUT_MUSIC_EXAMPLE_IMAGES = {
  SHIFT: '/assets/img/cut_music_examples/shift-illustration-v2.png',
  DROP: '/assets/img/cut_music_examples/drop-illustration-v2.png',
  EXAMPLE_0SEC: '/assets/img/cut_music_examples/example-0sec-v2.png',
  EXAMPLE_30SEC: '/assets/img/cut_music_examples/example-30sec-v2.png',
  EXAMPLE_60SEC: '/assets/img/cut_music_examples/example-60sec-v2.png',
};
